import { useState, useRef, useEffect } from "react";

const TEAL = "#0EA5A0";
const TEAL_LIGHT = "#E6F7F7";
const TEAL_DARK = "#0C8E89";
const GRAY = "#F5F7F8";
const TEXT = "#1A2B2B";
const TEXT_MUTED = "#7A9090";

const DEFAULT_PRODUCTS = [
  { id: 1, name: "皮肤舒缓护理喷雾", desc: "温和配方，日常皮肤护理，搭配护理使用更安心", price: "68", tag: "皮肤护理", emoji: "🧴" },
  { id: 2, name: "耳道清洁护理液", desc: "温和清洁耳道，日常护理猫狗耳部卫生", price: "52", tag: "耳部护理", emoji: "💧" },
  { id: 3, name: "宠物益生菌粉", desc: "调节肠道菌群，辅助维护消化健康", price: "89", tag: "肠胃护理", emoji: "🧪" },
  { id: 4, name: "眼部清洁护理液", desc: "温和清洁眼周分泌物，日常护理使用", price: "45", tag: "眼部护理", emoji: "👁️" },
  { id: 5, name: "关节营养补充咀嚼片", desc: "氨糖+软骨素成分，适合中老年犬猫日常营养补充", price: "128", tag: "关节养护", emoji: "🦴" },
  { id: 6, name: "宠物洁净沐浴露", desc: "天然草本配方，温和清洁，日常洗护使用", price: "76", tag: "日常洗护", emoji: "🛁" },
];

const EMOJI_OPTIONS = ["💊","💧","🧪","👁️","🦴","🛁","🐾","🩺","🌿","🍃","❤️","⭐"];

// ─── uniCloud 云函数地址 ──────────────────────────────────────────
// ⚠️ 如果你的服务空间域名变了，只需要改这一行
const CLOUD_BASE = "https://fc-mp-9c8e9106-fe5c-446c-8cd4-e960348d1041.next.bspapp.com";

async function callCloudFunction(name, body) {
  const options = { method: body ? "POST" : "GET" };
  if (body) {
    options.headers = { "Content-Type": "application/json" };
    options.body = JSON.stringify(body);
  }
  const res = await fetch(`${CLOUD_BASE}/${name}`, options);
  return res.json();
}

// ─── 商品：调用云函数 ─────────────────────────────────────────────
async function loadProducts() {
  try {
    const r = await callCloudFunction("getProducts");
    return r.code === 0 && r.data.length > 0 ? r.data : DEFAULT_PRODUCTS;
  } catch { return DEFAULT_PRODUCTS; }
}
async function saveOneProduct(product) {
  try { return await callCloudFunction("saveProduct", product); } catch { return null; }
}
async function deleteOneProduct(_id) {
  try { return await callCloudFunction("deleteProduct", { _id }); } catch { return null; }
}

// ─── 订单：调用云函数 ─────────────────────────────────────────────
async function loadOrders() {
  try {
    const r = await callCloudFunction("getOrders");
    return r.code === 0 ? r.data : [];
  } catch { return []; }
}
async function createOrder(order) {
  try { return await callCloudFunction("saveOrder", order); } catch { return null; }
}
async function updateOrder(_id, fields) {
  try { return await callCloudFunction("updateOrderStatus", { _id, ...fields }); } catch { return null; }
}

// ─── 诊断记录：调用云函数 ─────────────────────────────────────────
async function loadDiagnosisLogs() {
  try {
    const r = await callCloudFunction("getDiagnosisLogs");
    return r.code === 0 ? r.data : [];
  } catch { return []; }
}
async function appendDiagnosisLog(entry) {
  try { return await callCloudFunction("appendDiagnosisLog", entry); } catch { return null; }
}

// ─── AI diagnosis（已迁移到云函数，API Key 不再暴露在前端）─────────
async function diagnosePet(images, userDescription) {
  const r = await callCloudFunction("diagnosePet", { images, description: userDescription });
  if (r.code !== 0) {
    throw new Error(r.message || "诊断失败");
  }
  return r.data;
}

function severityColor(s) {
  if (s === "轻度") return "#22C55E";
  if (s === "中度") return "#F59E0B";
  return "#EF4444";
}

// ─── Input component ──────────────────────────────────────────────
function Field({ label, value, onChange, placeholder, type = "text", as }) {
  const style = {
    width: "100%", marginTop: 6, padding: "11px 13px", borderRadius: 10,
    border: "1.5px solid #E5EDED", fontSize: 14, color: TEXT,
    outline: "none", boxSizing: "border-box", background: GRAY,
    fontFamily: "inherit", resize: "vertical",
  };
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 12, color: TEXT_MUTED, fontWeight: 600 }}>{label}</div>
      {as === "textarea"
        ? <textarea rows={2} style={style} value={value} onChange={onChange} placeholder={placeholder} />
        : <input type={type} style={style} value={value} onChange={onChange} placeholder={placeholder} />
      }
    </div>
  );
}

// ─── Login Page ───────────────────────────────────────────────────
function LoginPage({ onLogin, isAdminPath }) {
  return (
    <div style={{
      minHeight: "100vh", background: "white", display: "flex",
      flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "32px 24px",
    }}>
      <div style={{ marginBottom: 32, textAlign: "center" }}>
        <div style={{
          width: 72, height: 72, borderRadius: 20, background: TEAL,
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 16px", fontSize: 36,
        }}>🐾</div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <div style={{ fontSize: 26, fontWeight: 800, color: TEXT, letterSpacing: -0.5 }}>{isAdminPath ? "宠物120 后台" : "宠物120"}</div>
          {!isAdminPath && (
            <span style={{ fontSize: 11, fontWeight: 700, color: TEAL_DARK, background: TEAL_LIGHT, padding: "2px 8px", borderRadius: 8 }}>测试版</span>
          )}
        </div>
        <div style={{ fontSize: 14, color: TEXT_MUTED, marginTop: 4 }}>{isAdminPath ? "管理员专用入口" : "宠物健康初诊助手 · 快速响应"}</div>
      </div>
      <div style={{
        width: "100%", maxWidth: 360, background: "white", borderRadius: 20,
        padding: "32px 28px", boxShadow: "0 4px 32px rgba(14,165,160,0.10)", border: "1px solid #EEF4F4",
      }}>
        <Field label="手机号 / 邮箱" placeholder="请输入账号" value="" onChange={() => {}} />
        <Field label="密码" type="password" placeholder="请输入密码" value="" onChange={() => {}} />
        <button onClick={() => onLogin(isAdminPath ? "admin" : "user")} style={{
          width: "100%", padding: "14px", borderRadius: 12, background: TEAL, color: "white",
          fontSize: 16, fontWeight: 700, border: "none", cursor: "pointer", letterSpacing: 1,
        }}>{isAdminPath ? "管理员登录" : "登录"}</button>
        {!isAdminPath && (
          <>
            <div style={{ textAlign: "center", marginTop: 10, fontSize: 12.5, color: TEAL_DARK, fontWeight: 600 }}>
              👉 无需注册，直接点击登录即可体验
            </div>
            <div style={{ textAlign: "center", marginTop: 10, fontSize: 13, color: TEXT_MUTED }}>
              还没有账号？<span style={{ color: TEAL, cursor: "pointer", fontWeight: 600 }}>立即注册</span>
            </div>
          </>
        )}
      </div>
      <div style={{ marginTop: 32, fontSize: 12, color: "#C0CCCC" }}>仅供参考，不替代专业兽医诊断</div>
    </div>
  );
}

// ─── Diagnosis Page ───────────────────────────────────────────────
const MAX_IMAGES = 3;

function DiagnosisPage({ onGoShop }) {
  const [images, setImages] = useState([]); // [{ preview, data, type }]
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const fileRef = useRef();

  const handleFile = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setResult(null); setError(null);

    const remainingSlots = MAX_IMAGES - images.length;
    const filesToAdd = files.slice(0, remainingSlots);

    filesToAdd.forEach(file => {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setImages(prev => {
          if (prev.length >= MAX_IMAGES) return prev;
          return [...prev, {
            preview: ev.target.result,
            data: ev.target.result.split(",")[1],
            type: file.type,
          }];
        });
      };
      reader.readAsDataURL(file);
    });
    e.target.value = ""; // 允许重复选择同一文件
  };

  const removeImage = (index) => {
    setImages(prev => prev.filter((_, i) => i !== index));
    setResult(null);
  };

  const handleDiagnose = async () => {
    if (images.length === 0) return;
    setLoading(true); setError(null); setResult(null);
    try {
      const diagResult = await diagnosePet(images, description);
      setResult(diagResult);
      if (diagResult.isPet !== false) {
        appendDiagnosisLog({
          condition: diagResult.condition,
          severity: diagResult.severity,
          urgency: diagResult.urgency,
          recommendedProductType: diagResult.recommendedProductType || "",
        });
      }
    } catch { setError("诊断失败，请重试"); }
    setLoading(false);
  };

  return (
    <div style={{ padding: "24px 20px 100px", background: "white", minHeight: "100vh" }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>宠物健康诊断</div>
        <div style={{ fontSize: 14, color: TEXT_MUTED, marginTop: 4 }}>上传宠物照片，AI 给出初步分析</div>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ fontSize: 13, color: TEXT, fontWeight: 700 }}>上传照片</div>
        <div style={{ fontSize: 12, color: TEXT_MUTED }}>{images.length} / {MAX_IMAGES} 张</div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
        {images.map((img, i) => (
          <div key={i} style={{ position: "relative", borderRadius: 14, overflow: "hidden", border: `1.5px solid ${TEAL}`, aspectRatio: "1" }}>
            <img src={img.preview} alt={`宠物照片${i + 1}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            <button onClick={() => removeImage(i)} style={{
              position: "absolute", top: 4, right: 4, width: 22, height: 22, borderRadius: "50%",
              background: "rgba(0,0,0,0.55)", color: "white", border: "none", fontSize: 14,
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1,
            }}>×</button>
          </div>
        ))}

        {images.length < MAX_IMAGES && (
          <div onClick={() => fileRef.current.click()} style={{
            border: "2px dashed #D4E8E8", borderRadius: 14, background: GRAY, cursor: "pointer",
            aspectRatio: "1", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 4,
          }}>
            <div style={{ fontSize: 28 }}>📷</div>
            <div style={{ fontSize: 11, color: TEAL, fontWeight: 700 }}>添加照片</div>
          </div>
        )}
      </div>
      <input ref={fileRef} type="file" accept="image/*" multiple style={{ display: "none" }} onChange={handleFile} />

      {images.length === 0 && (
        <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 8, textAlign: "center" }}>
          支持上传 1-3 张照片，建议清晰拍摄患处、可从不同角度补充
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <div style={{ fontSize: 13, color: TEXT, fontWeight: 700, marginBottom: 8 }}>补充描述 <span style={{ color: TEXT_MUTED, fontWeight: 400 }}>（选填，但能大幅提升判断准确度）</span></div>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="例：已经挠了3天，这两天开始脱毛；精神食欲正常；没有呕吐腹泻……"
          rows={3}
          style={{
            width: "100%", padding: "12px 14px", borderRadius: 12,
            border: "1.5px solid #E5EDED", fontSize: 14, color: TEXT,
            outline: "none", boxSizing: "border-box", background: GRAY,
            fontFamily: "inherit", resize: "vertical",
          }}
        />
      </div>

      <div style={{ marginTop: 16, padding: "12px 14px", background: TEAL_LIGHT, borderRadius: 12, fontSize: 13, color: TEAL_DARK }}>
        💡 <strong>拍摄建议：</strong>光线充足、患处清晰可见，也可以拍摄呕吐物、排泄物等异常情况
      </div>

      <button onClick={handleDiagnose} disabled={images.length === 0 || loading} style={{
        width: "100%", marginTop: 16, padding: "15px", borderRadius: 14,
        background: (images.length === 0 || loading) ? "#C8E8E7" : TEAL, color: "white",
        fontSize: 16, fontWeight: 700, border: "none",
        cursor: (images.length === 0 || loading) ? "not-allowed" : "pointer",
      }}>
        {loading ? "🔍 AI 分析中..." : "开始诊断"}
      </button>

      {error && <div style={{ marginTop: 14, padding: "12px 14px", background: "#FEF2F2", borderRadius: 10, color: "#EF4444", fontSize: 14 }}>⚠️ {error}</div>}

      {result && result.isPet === false && (
        <div style={{ marginTop: 24, borderRadius: 18, padding: "32px 24px", background: GRAY, border: "1.5px dashed #D4E0E0", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🐾</div>
          <div style={{ fontSize: 15, color: TEXT, lineHeight: 1.7 }}>
            {result.nonPetMessage || "这张照片好像不是宠物呢，请重新上传宠物的照片试试～"}
          </div>
        </div>
      )}

      {result && result.isPet !== false && (
        <div style={{ marginTop: 24, borderRadius: 18, overflow: "hidden", border: `1.5px solid ${TEAL}`, boxShadow: "0 4px 24px rgba(14,165,160,0.12)" }}>
          <div style={{ background: TEAL, padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <div style={{ color: "white", fontWeight: 800, fontSize: 16 }}>📋 AI 诊断病历</div>
              <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 12, marginTop: 2 }}>{new Date().toLocaleDateString("zh-CN")}</div>
            </div>
            <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: 8, padding: "4px 12px", fontSize: 13, color: "white", fontWeight: 700 }}>
              置信度：{result.confidence}
            </div>
          </div>
          <div style={{ background: "white", padding: "20px" }}>
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, color: TEXT_MUTED, marginBottom: 4, fontWeight: 600 }}>初步判断</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: TEXT }}>{result.condition}</div>
            </div>
            <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
              <span style={{ padding: "5px 14px", borderRadius: 20, fontSize: 13, fontWeight: 700, background: severityColor(result.severity) + "20", color: severityColor(result.severity) }}>{result.severity}</span>
              <span style={{ padding: "5px 14px", borderRadius: 20, fontSize: 13, fontWeight: 600, background: TEAL_LIGHT, color: TEAL_DARK }}>{result.urgency}</span>
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, color: TEXT_MUTED, marginBottom: 8, fontWeight: 600 }}>观察到的症状</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {result.symptoms?.map((s, i) => <span key={i} style={{ padding: "4px 12px", background: GRAY, borderRadius: 20, fontSize: 13, color: TEXT }}>{s}</span>)}
              </div>
            </div>
            <div style={{ padding: "14px", background: GRAY, borderRadius: 12, fontSize: 14, color: TEXT, lineHeight: 1.7, marginBottom: 12 }}>
              <div style={{ fontWeight: 700, marginBottom: 6, color: TEAL_DARK }}>🩺 居家处理建议</div>
              {result.advice}
            </div>
            {result.recommendedProductType && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: TEAL_LIGHT, borderRadius: 12, padding: "12px 16px", marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 11, color: TEAL_DARK, fontWeight: 600 }}>推荐使用</div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: TEXT }}>{result.recommendedProductType}</div>
                </div>
                <button onClick={onGoShop} style={{ padding: "8px 16px", borderRadius: 8, background: TEAL, color: "white", border: "none", fontSize: 13, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
                  去看看 →
                </button>
              </div>
            )}
            <div style={{ fontSize: 12, color: TEXT_MUTED, textAlign: "center" }}>⚠️ {result.disclaimer}</div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Profile Page (我的，占位) ───────────────────────────────────────
function ProfilePage() {
  const sections = [
    { icon: "👤", title: "我的账号", desc: "登录方式、个人信息" },
    { icon: "🐾", title: "我的宠物", desc: "添加宠物档案，记录基本信息" },
    { icon: "📋", title: "诊断历史", desc: "查看过往诊断记录" },
    { icon: "🧾", title: "我的购买", desc: "查看历史订单和物流状态" },
    { icon: "💬", title: "意见反馈", desc: "告诉我们诊断准不准、好不好用" },
    { icon: "⚙️", title: "设置", desc: "通知、隐私、关于我们" },
  ];

  return (
    <div style={{ padding: "24px 20px 100px", background: "white", minHeight: "100vh" }}>
      {/* 用户信息卡片占位 */}
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 28 }}>
        <div style={{ width: 56, height: 56, borderRadius: "50%", background: TEAL_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>
          🐾
        </div>
        <div>
          <div style={{ fontSize: 17, fontWeight: 800, color: TEXT }}>宠物家长</div>
          <div style={{ fontSize: 12.5, color: TEXT_MUTED, marginTop: 2 }}>登录功能即将上线</div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {sections.map((s) => (
          <div key={s.title} style={{
            display: "flex", alignItems: "center", gap: 14, padding: "16px",
            borderRadius: 14, background: GRAY, border: "1.5px solid #EEF4F4",
            opacity: 0.7,
          }}>
            <div style={{ width: 42, height: 42, borderRadius: 12, background: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>
              {s.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>{s.title}</div>
              <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 2 }}>{s.desc}</div>
            </div>
            <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 10, background: "#EEF1F1", color: TEXT_MUTED, fontWeight: 600 }}>
              待开发
            </span>
          </div>
        ))}
      </div>

      <div style={{ textAlign: "center", marginTop: 28, fontSize: 12, color: "#C0CCCC" }}>
        宠物120 · 持续完善中 🐾
      </div>
    </div>
  );
}

// ─── Knowledge Page (科普，占位) ─────────────────────────────────────
function KnowledgePage() {
  const categories = [
    { icon: "🐶", title: "犬类护理", desc: "常见犬种护理要点、行为解读" },
    { icon: "🐱", title: "猫咪护理", desc: "猫咪日常习性、健康小贴士" },
    { icon: "🍽️", title: "饮食营养", desc: "科学喂养、常见食物禁忌" },
    { icon: "🧼", title: "日常护理", desc: "洗护、驱虫、疫苗周期科普" },
    { icon: "🚨", title: "应急常识", desc: "紧急情况下的初步处理方法" },
  ];

  return (
    <div style={{ padding: "24px 20px 100px", background: "white", minHeight: "100vh" }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>宠物科普</div>
        <div style={{ fontSize: 14, color: TEXT_MUTED, marginTop: 4 }}>实用知识，让养宠更省心</div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {categories.map((c) => (
          <div key={c.title} style={{
            display: "flex", alignItems: "center", gap: 14, padding: "16px",
            borderRadius: 14, background: GRAY, border: "1.5px solid #EEF4F4",
            opacity: 0.7,
          }}>
            <div style={{ width: 42, height: 42, borderRadius: 12, background: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>
              {c.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>{c.title}</div>
              <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 2 }}>{c.desc}</div>
            </div>
            <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 10, background: "#EEF1F1", color: TEXT_MUTED, fontWeight: 600 }}>
              内容筹备中
            </span>
          </div>
        ))}
      </div>

      <div style={{ textAlign: "center", marginTop: 28, fontSize: 12, color: "#C0CCCC" }}>
        宠物120 · 持续完善中 🐾
      </div>
    </div>
  );
}

// ─── Shop Page ────────────────────────────────────────────────────
function ShopPage() {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState({}); // { productId: qty }
  const [search, setSearch] = useState("");
  const [view, setView] = useState("list"); // list | cart
  const [orderModal, setOrderModal] = useState(null); // null | order object

  useEffect(() => { loadProducts().then(setProducts); }, []);

  const filtered = products.filter(p =>
    p.name.includes(search) || p.tag.includes(search) || p.desc.includes(search)
  );

  const cartCount = Object.values(cart).reduce((a, b) => a + b, 0);
  const cartItems = Object.entries(cart)
    .map(([_id, qty]) => ({ ...products.find(p => p._id === _id), qty }))
    .filter(item => item._id);
  const cartTotal = cartItems.reduce((sum, item) => sum + Number(item.price) * item.qty, 0);

  const addToCart = (id) => setCart(prev => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
  const changeQty = (id, delta) => setCart(prev => {
    const next = { ...prev };
    const newQty = (next[id] || 0) + delta;
    if (newQty <= 0) { delete next[id]; } else { next[id] = newQty; }
    return next;
  });
  const removeFromCart = (id) => setCart(prev => {
    const next = { ...prev };
    delete next[id];
    return next;
  });

  const handleCheckout = async () => {
    const orderId = "PT" + Date.now().toString().slice(-8);
    const result = await createOrder({
      orderId,
      items: cartItems,
      total: cartTotal,
      payMethod: null,
    });

    if (result && result.code === 0) {
      // 把云函数返回的数据统一成前端展示需要的字段格式（id 用 orderId 而非数据库 _id，便于展示）
      setOrderModal({ ...result.data, id: result.data.orderId, date: result.data.dateText });
      setCart({});
    }
  };

  // ── 购物车视图 ──
  if (view === "cart") {
    return (
      <div style={{ padding: "24px 20px 100px", background: "white", minHeight: "100vh" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
          <button onClick={() => setView("list")} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: TEXT }}>←</button>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>购物车</div>
        </div>

        {cartItems.length === 0 ? (
          <div style={{ textAlign: "center", padding: "80px 0", color: TEXT_MUTED }}>
            <div style={{ fontSize: 44, marginBottom: 14 }}>🛒</div>
            <div style={{ fontSize: 15 }}>购物车空空如也</div>
            <button onClick={() => setView("list")} style={{ marginTop: 20, padding: "10px 24px", borderRadius: 10, background: TEAL, color: "white", border: "none", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
              去逛逛
            </button>
          </div>
        ) : (
          <>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {cartItems.map(item => (
                <div key={item._id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "16px", borderRadius: 14, background: GRAY, border: "1.5px solid #EEF4F4" }}>
                  <div style={{ width: 48, height: 48, borderRadius: 12, background: TEAL_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
                    {item.emoji || "💊"}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: TEXT }}>{item.name}</div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: TEAL, marginTop: 4 }}>¥{item.price}</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <button onClick={() => changeQty(item._id, -1)} style={{ width: 28, height: 28, borderRadius: 8, border: `1.5px solid ${TEAL}`, background: "white", color: TEAL, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                    <span style={{ fontSize: 14, fontWeight: 700, minWidth: 18, textAlign: "center" }}>{item.qty}</span>
                    <button onClick={() => changeQty(item._id, 1)} style={{ width: 28, height: 28, borderRadius: 8, border: `1.5px solid ${TEAL}`, background: "white", color: TEAL, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
                  </div>
                  <button onClick={() => removeFromCart(item._id)} style={{ background: "none", border: "none", color: "#EF4444", fontSize: 13, cursor: "pointer", marginLeft: 4 }}>删除</button>
                </div>
              ))}
            </div>

            <div style={{ position: "fixed", bottom: 70, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: 520, background: "white", borderTop: "1px solid #EEF4F4", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 -4px 20px rgba(0,0,0,0.06)" }}>
              <div>
                <span style={{ fontSize: 13, color: TEXT_MUTED }}>合计：</span>
                <span style={{ fontSize: 20, fontWeight: 800, color: TEAL }}>¥{cartTotal}</span>
              </div>
              <button onClick={handleCheckout} style={{ padding: "12px 28px", borderRadius: 12, background: TEAL, color: "white", border: "none", fontSize: 15, fontWeight: 800, cursor: "pointer" }}>
                提交订单
              </button>
            </div>
          </>
        )}

        {orderModal && <OrderSuccessModal order={orderModal} onClose={() => setOrderModal(null)} />}
      </div>
    );
  }

  // ── 商品列表视图 ──
  return (
    <div style={{ padding: "24px 20px 100px", background: "white", minHeight: "100vh" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>宠物健康商品</div>
          <div style={{ fontSize: 14, color: TEXT_MUTED, marginTop: 4 }}>精选常用宠物健康产品</div>
        </div>
        <button onClick={() => setView("cart")} style={{ position: "relative", background: GRAY, border: "1.5px solid #EEF4F4", borderRadius: 12, width: 44, height: 44, fontSize: 20, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
          🛒
          {cartCount > 0 && (
            <span style={{ position: "absolute", top: -6, right: -6, background: "#EF4444", color: "white", borderRadius: 10, fontSize: 11, fontWeight: 700, padding: "1px 6px", minWidth: 18 }}>{cartCount}</span>
          )}
        </button>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10, background: GRAY, borderRadius: 12, padding: "10px 14px", marginBottom: 20, border: "1.5px solid #EEF4F4" }}>
        <span>🔍</span>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="搜索商品..."
          style={{ flex: 1, border: "none", background: "transparent", fontSize: 14, color: TEXT, outline: "none" }} />
      </div>

      {filtered.length === 0 && (
        <div style={{ textAlign: "center", padding: "40px 0", color: TEXT_MUTED, fontSize: 14 }}>暂无相关商品</div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {filtered.map((p) => {
          const qty = cart[p._id] || 0;
          return (
            <div key={p._id} style={{
              display: "flex", alignItems: "center", gap: 14, padding: "16px", borderRadius: 14,
              background: "white", border: `1.5px solid ${qty > 0 ? TEAL : "#EEF4F4"}`,
              transition: "border-color 0.2s", boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            }}>
              <div style={{ width: 52, height: 52, borderRadius: 12, background: TEAL_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0 }}>
                {p.emoji || "💊"}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 15, color: TEXT }}>{p.name}</div>
                <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 3, lineHeight: 1.5 }}>{p.desc}</div>
                <div style={{ marginTop: 6, display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 16, fontWeight: 800, color: TEAL }}>¥{p.price}</span>
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: TEAL_LIGHT, color: TEAL_DARK, fontWeight: 600 }}>{p.tag}</span>
                </div>
              </div>
              {qty === 0 ? (
                <button onClick={() => addToCart(p._id)}
                  style={{ width: 36, height: 36, borderRadius: 10, flexShrink: 0, background: "white", border: `2px solid ${TEAL}`, color: TEAL, fontSize: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                  +
                </button>
              ) : (
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                  <button onClick={() => changeQty(p._id, -1)} style={{ width: 28, height: 28, borderRadius: 8, border: `1.5px solid ${TEAL}`, background: "white", color: TEAL, fontSize: 15, cursor: "pointer" }}>−</button>
                  <span style={{ fontSize: 14, fontWeight: 700, minWidth: 16, textAlign: "center" }}>{qty}</span>
                  <button onClick={() => changeQty(p._id, 1)} style={{ width: 28, height: 28, borderRadius: 8, border: `1.5px solid ${TEAL}`, background: TEAL, color: "white", fontSize: 15, cursor: "pointer" }}>+</button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {cartCount > 0 && (
        <div onClick={() => setView("cart")} style={{ position: "fixed", bottom: 72, left: "50%", transform: "translateX(-50%)", width: "calc(100% - 40px)", maxWidth: 480, background: TEAL, borderRadius: 14, padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 4px 20px rgba(14,165,160,0.35)", cursor: "pointer" }}>
          <div style={{ color: "white", fontWeight: 700 }}>🛒 已选 {cartCount} 件商品 · ¥{Object.entries(cart).reduce((sum, [_id, qty]) => { const p = products.find(x => x._id === _id); return sum + (p ? Number(p.price) * qty : 0); }, 0)}</div>
          <button style={{ background: "white", color: TEAL, border: "none", borderRadius: 10, padding: "8px 18px", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>去结算</button>
        </div>
      )}
    </div>
  );
}

// ─── Order Chat Modal (后台对话式收款) ─────────────────────────────
function OrderSuccessModal({ order, onClose }) {
  const [messages, setMessages] = useState([
    { from: "system", text: `订单已生成，订单号 ${order.id}` },
    { from: "service", text: "您好，订单已收到～请问您方便使用微信支付还是支付宝付款呢？" },
  ]);
  const [stage, setStage] = useState("choosing"); // choosing | waiting | done
  const [input, setInput] = useState("");

  const choosePay = async (method) => {
    setMessages(prev => [
      ...prev,
      { from: "user", text: method === "wechat" ? "微信支付" : "支付宝" },
      { from: "service", text: `好的，正在为您发送${method === "wechat" ? "微信" : "支付宝"}收款码，请稍候...`, pending: true },
    ]);
    setStage("waiting");

    // 把用户选择的支付方式同步更新到订单记录里，方便后台查看
    if (order._id) {
      await updateOrder(order._id, { payMethod: method });
    }

    // 模拟客服延迟回复（实际场景中这里由人工后台发送真实二维码图片）
    setTimeout(() => {
      setMessages(prev => prev.map(m => m.pending ? { ...m, pending: false } : m));
      setStage("done");
    }, 1500);
  };

  const sendUserMessage = () => {
    if (!input.trim()) return;
    setMessages(prev => [...prev, { from: "user", text: input.trim() }]);
    setInput("");
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ width: "100%", maxWidth: 380, background: "white", borderRadius: 20, overflow: "hidden", maxHeight: "85vh", display: "flex", flexDirection: "column" }}>

        {/* 顶部栏 */}
        <div style={{ background: TEAL, padding: "16px 18px", display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(255,255,255,0.25)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>👩‍💼</div>
          <div style={{ flex: 1 }}>
            <div style={{ color: "white", fontWeight: 800, fontSize: 14 }}>宠物120 客服</div>
            <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 11 }}>订单号 {order.id}</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer" }}>×</button>
        </div>

        {/* 订单摘要 */}
        <div style={{ background: GRAY, padding: "10px 18px", fontSize: 12, color: TEXT_MUTED, borderBottom: "1px solid #EEF4F4" }}>
          {order.items.map(i => i.name + "×" + i.qty).join("、")} · 合计 <span style={{ color: TEAL, fontWeight: 800 }}>¥{order.total}</span>
        </div>

        {/* 对话区 */}
        <div style={{ flex: 1, overflowY: "auto", padding: "16px 18px", display: "flex", flexDirection: "column", gap: 12, minHeight: 220 }}>
          {messages.map((m, i) => {
            if (m.from === "system") {
              return <div key={i} style={{ textAlign: "center", fontSize: 11, color: TEXT_MUTED }}>{m.text}</div>;
            }
            const isUser = m.from === "user";
            return (
              <div key={i} style={{ display: "flex", justifyContent: isUser ? "flex-end" : "flex-start" }}>
                <div style={{
                  maxWidth: "75%", padding: "10px 14px", borderRadius: 14, fontSize: 14, lineHeight: 1.5,
                  background: isUser ? TEAL : GRAY, color: isUser ? "white" : TEXT,
                  opacity: m.pending ? 0.6 : 1,
                }}>
                  {m.text}
                  {m.pending && <span style={{ marginLeft: 4 }}>⏳</span>}
                </div>
              </div>
            );
          })}

          {stage === "done" && (
            <div style={{ background: "#FFF7E6", borderRadius: 12, padding: "12px 14px", fontSize: 12.5, color: "#92600A", lineHeight: 1.6 }}>
              💬 这是演示版本，实际收款码由客服在后台手动发送给您。转账时请备注订单号 <strong>{order.id}</strong>，确认到账后我们会在 30 分钟内安排发货。
            </div>
          )}
        </div>

        {/* 底部操作区 */}
        <div style={{ borderTop: "1px solid #EEF4F4", padding: "14px 18px" }}>
          {stage === "choosing" && (
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => choosePay("wechat")} style={{ flex: 1, padding: "11px 0", borderRadius: 12, border: "1.5px solid #07C160", background: "white", color: "#07C160", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                💚 微信支付
              </button>
              <button onClick={() => choosePay("alipay")} style={{ flex: 1, padding: "11px 0", borderRadius: 12, border: "1.5px solid #1677FF", background: "white", color: "#1677FF", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                💙 支付宝
              </button>
            </div>
          )}
          {stage === "waiting" && (
            <div style={{ textAlign: "center", fontSize: 13, color: TEXT_MUTED, padding: "8px 0" }}>客服正在发送收款码...</div>
          )}
          {stage === "done" && (
            <button onClick={onClose} style={{ width: "100%", padding: "12px", borderRadius: 12, background: TEAL, color: "white", border: "none", fontSize: 15, fontWeight: 700, cursor: "pointer" }}>
              我知道了，关闭对话
            </button>
          )}
        </div>

      </div>
    </div>
  );
}

// ─── Admin Page ───────────────────────────────────────────────────
function AdminPage({ products, setProducts }) {
  const [section, setSection] = useState("products"); // products | orders
  const EMPTY = { name: "", desc: "", price: "", tag: "", emoji: "💊" };
  const [editing, setEditing] = useState(null); // null | "new" | product
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState("");

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2000); };

  const openNew = () => { setForm(EMPTY); setEditing("new"); };
  const openEdit = (p) => { setForm({ ...p }); setEditing(p); };
  const closeForm = () => { setEditing(null); setForm(EMPTY); };

  const f = (key) => (e) => setForm(prev => ({ ...prev, [key]: e.target.value }));

  const handleSave = async () => {
    if (!form.name.trim() || !form.price.trim()) return;
    setSaving(true);
    const payload = editing === "new"
      ? { name: form.name, desc: form.desc, price: form.price, tag: form.tag, emoji: form.emoji }
      : { _id: editing._id, name: form.name, desc: form.desc, price: form.price, tag: form.tag, emoji: form.emoji };

    const result = await saveOneProduct(payload);
    if (result && result.code === 0) {
      const refreshed = await loadProducts();
      setProducts(refreshed);
      showToast(editing === "new" ? "✅ 商品已添加" : "✅ 商品已更新");
    } else {
      showToast("⚠️ 保存失败，请重试");
    }
    setSaving(false);
    closeForm();
  };

  const handleDelete = async (_id) => {
    const result = await deleteOneProduct(_id);
    if (result && result.code === 0) {
      const refreshed = await loadProducts();
      setProducts(refreshed);
      showToast("🗑️ 已删除");
    } else {
      showToast("⚠️ 删除失败，请重试");
    }
  };

  return (
    <div style={{ padding: "24px 20px 100px", background: "white", minHeight: "100vh" }}>
      {/* Toast */}
      {toast && (
        <div style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", background: TEXT, color: "white", padding: "10px 20px", borderRadius: 10, fontSize: 14, fontWeight: 600, zIndex: 999 }}>{toast}</div>
      )}

      {/* 内部 Tab：商品管理 / 订单管理 / 数据统计 */}
      <div style={{ display: "flex", background: GRAY, borderRadius: 12, padding: 4, marginBottom: 22 }}>
        <button onClick={() => setSection("products")} style={{
          flex: 1, padding: "9px 0", borderRadius: 9, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 700,
          background: section === "products" ? "white" : "transparent",
          color: section === "products" ? TEAL : TEXT_MUTED,
          boxShadow: section === "products" ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
        }}>📦 商品</button>
        <button onClick={() => setSection("orders")} style={{
          flex: 1, padding: "9px 0", borderRadius: 9, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 700,
          background: section === "orders" ? "white" : "transparent",
          color: section === "orders" ? TEAL : TEXT_MUTED,
          boxShadow: section === "orders" ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
        }}>🧾 订单</button>
        <button onClick={() => setSection("stats")} style={{
          flex: 1, padding: "9px 0", borderRadius: 9, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 700,
          background: section === "stats" ? "white" : "transparent",
          color: section === "stats" ? TEAL : TEXT_MUTED,
          boxShadow: section === "stats" ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
        }}>📊 数据统计</button>
      </div>

      {section === "stats" ? (
        <StatsPage />
      ) : section === "orders" ? (
        <OrderManagement showToast={showToast} />
      ) : (
      <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>商品管理</div>
          <div style={{ fontSize: 14, color: TEXT_MUTED, marginTop: 4 }}>共 {products.length} 件商品</div>
        </div>
        <button onClick={openNew} style={{ padding: "10px 18px", borderRadius: 12, background: TEAL, color: "white", fontSize: 14, fontWeight: 700, border: "none", cursor: "pointer" }}>
          + 添加商品
        </button>
      </div>

      {/* Product list */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {products.map(p => (
          <div key={p._id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px", borderRadius: 14, background: GRAY, border: "1.5px solid #EEF4F4" }}>
            <div style={{ width: 44, height: 44, borderRadius: 10, background: TEAL_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
              {p.emoji || "💊"}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: TEXT }}>{p.name}</div>
              <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 2 }}>¥{p.price} · {p.tag}</div>
            </div>
            <button onClick={() => openEdit(p)} style={{ padding: "6px 12px", borderRadius: 8, background: "white", border: `1.5px solid ${TEAL}`, color: TEAL, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>编辑</button>
            <button onClick={() => handleDelete(p._id)} style={{ padding: "6px 12px", borderRadius: 8, background: "white", border: "1.5px solid #FCA5A5", color: "#EF4444", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>删除</button>
          </div>
        ))}
      </div>

      {products.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 0", color: TEXT_MUTED }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>📦</div>
          <div>暂无商品，点击「添加商品」开始吧</div>
        </div>
      )}

      {/* Modal overlay */}
      {editing !== null && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "flex-end", justifyContent: "center" }}
          onClick={(e) => { if (e.target === e.currentTarget) closeForm(); }}>
          <div style={{ width: "100%", maxWidth: 520, background: "white", borderRadius: "20px 20px 0 0", padding: "28px 24px 40px", maxHeight: "90vh", overflowY: "auto" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 22 }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: TEXT }}>{editing === "new" ? "添加新商品" : "编辑商品"}</div>
              <button onClick={closeForm} style={{ background: "none", border: "none", fontSize: 22, color: TEXT_MUTED, cursor: "pointer" }}>×</button>
            </div>

            {/* Emoji picker */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: TEXT_MUTED, fontWeight: 600, marginBottom: 8 }}>图标</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {EMOJI_OPTIONS.map(em => (
                  <button key={em} onClick={() => setForm(prev => ({ ...prev, emoji: em }))}
                    style={{ width: 40, height: 40, borderRadius: 10, fontSize: 20, background: form.emoji === em ? TEAL_LIGHT : GRAY, border: `2px solid ${form.emoji === em ? TEAL : "transparent"}`, cursor: "pointer" }}>
                    {em}
                  </button>
                ))}
              </div>
            </div>

            <Field label="商品名称 *" value={form.name} onChange={f("name")} placeholder="例：皮肤抗菌喷雾" />
            <Field label="商品描述" value={form.desc} onChange={f("desc")} placeholder="简短描述用途和适用对象" as="textarea" />

            <div style={{ display: "flex", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <Field label="价格（元）*" value={form.price} onChange={f("price")} placeholder="68" type="number" />
              </div>
              <div style={{ flex: 1 }}>
                <Field label="分类标签" value={form.tag} onChange={f("tag")} placeholder="皮肤病" />
              </div>
            </div>

            <button onClick={handleSave} disabled={saving || !form.name.trim() || !form.price.trim()}
              style={{ width: "100%", padding: "14px", borderRadius: 12, background: (!form.name.trim() || !form.price.trim()) ? "#C8E8E7" : TEAL, color: "white", fontSize: 15, fontWeight: 700, border: "none", cursor: "pointer", marginTop: 4 }}>
              {saving ? "保存中..." : (editing === "new" ? "添加商品" : "保存修改")}
            </button>
          </div>
        </div>
      )}
      </>
      )}
    </div>
  );
}

// ─── Order Management (订单管理) ────────────────────────────────────
function OrderManagement({ showToast }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("全部");

  const refresh = async () => {
    setLoading(true);
    setOrders(await loadOrders());
    setLoading(false);
  };

  useEffect(() => { refresh(); }, []);

  const updateStatus = async (_id, status) => {
    const result = await updateOrder(_id, { status });
    if (result && result.code === 0) {
      const refreshed = await loadOrders();
      setOrders(refreshed);
      showToast(`✅ 订单状态已更新为「${status}」`);
    } else {
      showToast("⚠️ 更新失败，请重试");
    }
  };

  const STATUS_OPTIONS = ["待确认", "已收款", "已发货", "已取消"];
  const statusColor = (s) => {
    if (s === "待确认") return "#F59E0B";
    if (s === "已收款") return "#0EA5A0";
    if (s === "已发货") return "#22C55E";
    return "#9CA3AF";
  };

  const filtered = filter === "全部" ? orders : orders.filter(o => o.status === filter);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>订单管理</div>
          <div style={{ fontSize: 14, color: TEXT_MUTED, marginTop: 4 }}>共 {orders.length} 笔订单</div>
        </div>
        <button onClick={refresh} style={{ padding: "8px 14px", borderRadius: 10, background: GRAY, border: "1.5px solid #EEF4F4", color: TEXT_MUTED, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
          🔄 刷新
        </button>
      </div>

      {/* 状态筛选 */}
      <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
        {["全部", ...STATUS_OPTIONS].map(s => (
          <button key={s} onClick={() => setFilter(s)} style={{
            padding: "6px 14px", borderRadius: 20, fontSize: 12.5, fontWeight: 700, cursor: "pointer",
            border: `1.5px solid ${filter === s ? TEAL : "#E5EDED"}`,
            background: filter === s ? TEAL_LIGHT : "white",
            color: filter === s ? TEAL_DARK : TEXT_MUTED,
          }}>{s}</button>
        ))}
      </div>

      {loading && <div style={{ textAlign: "center", padding: "40px 0", color: TEXT_MUTED }}>加载中...</div>}

      {!loading && filtered.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 0", color: TEXT_MUTED }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🧾</div>
          <div>暂无{filter !== "全部" ? `「${filter}」` : ""}订单</div>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {filtered.map(order => (
          <div key={order._id} style={{ borderRadius: 14, border: "1.5px solid #EEF4F4", overflow: "hidden" }}>
            <div style={{ background: GRAY, padding: "10px 14px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ fontSize: 12.5, color: TEXT_MUTED, fontWeight: 600 }}>{order.orderId} · {order.dateText}</div>
              <span style={{ fontSize: 11.5, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: statusColor(order.status) + "20", color: statusColor(order.status) }}>
                {order.status}
              </span>
            </div>
            <div style={{ padding: "12px 14px" }}>
              {order.items.map((item, i) => (
                <div key={item._id || i} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: TEXT, marginBottom: 4 }}>
                  <span>{item.name} × {item.qty}</span>
                  <span>¥{Number(item.price) * item.qty}</span>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, paddingTop: 8, borderTop: "1px solid #EEF4F4" }}>
                <span style={{ fontSize: 13, color: TEXT_MUTED }}>
                  支付方式：{order.payMethod === "wechat" ? "微信支付" : order.payMethod === "alipay" ? "支付宝" : "未选择"}
                </span>
                <span style={{ fontSize: 15, fontWeight: 800, color: TEAL }}>合计 ¥{order.total}</span>
              </div>

              {/* 状态操作按钮 */}
              <div style={{ display: "flex", gap: 6, marginTop: 12, flexWrap: "wrap" }}>
                {STATUS_OPTIONS.filter(s => s !== order.status).map(s => (
                  <button key={s} onClick={() => updateStatus(order._id, s)} style={{
                    padding: "5px 12px", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer",
                    border: `1.5px solid ${statusColor(s)}`, background: "white", color: statusColor(s),
                  }}>
                    标记为{s}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Stats Page (数据统计) ───────────────────────────────────────────
function StatsPage() {
  const [logs, setLogs] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    const [diagLogs, orderList] = await Promise.all([loadDiagnosisLogs(), loadOrders()]);
    setLogs(diagLogs);
    setOrders(orderList);
    setLoading(false);
  };

  useEffect(() => { refresh(); }, []);

  if (loading) {
    return <div style={{ textAlign: "center", padding: "60px 0", color: TEXT_MUTED }}>加载中...</div>;
  }

  // ── 计算统计指标 ──
  const totalDiagnoses = logs.length;
  const totalOrders = orders.length;
  const totalRevenue = orders.reduce((sum, o) => sum + Number(o.total || 0), 0);

  const conditionCounts = {};
  logs.forEach(l => {
    if (l.condition) conditionCounts[l.condition] = (conditionCounts[l.condition] || 0) + 1;
  });
  const topConditions = Object.entries(conditionCounts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  const severityCounts = { 轻度: 0, 中度: 0, 重度: 0 };
  logs.forEach(l => { if (severityCounts[l.severity] !== undefined) severityCounts[l.severity]++; });

  const orderStatusCounts = {};
  orders.forEach(o => { orderStatusCounts[o.status] = (orderStatusCounts[o.status] || 0) + 1; });

  // 今日数据
  const todayStr = new Date().toDateString();
  const todayDiagnoses = logs.filter(l => new Date(l.createdAt).toDateString() === todayStr).length;

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>数据统计</div>
          <div style={{ fontSize: 14, color: TEXT_MUTED, marginTop: 4 }}>全局运营数据概览</div>
        </div>
        <button onClick={refresh} style={{ padding: "8px 14px", borderRadius: 10, background: GRAY, border: "1.5px solid #EEF4F4", color: TEXT_MUTED, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
          🔄 刷新
        </button>
      </div>

      {/* 核心指标卡片 */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
        <StatCard icon="🔬" label="累计诊断次数" value={totalDiagnoses} />
        <StatCard icon="📅" label="今日诊断" value={todayDiagnoses} />
        <StatCard icon="🧾" label="累计订单数" value={totalOrders} />
        <StatCard icon="💰" label="累计订单金额" value={`¥${totalRevenue}`} />
      </div>

      {/* 病症 Top5 */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: TEXT, marginBottom: 10 }}>📋 最常见病症 Top 5</div>
        {topConditions.length === 0 ? (
          <div style={{ fontSize: 13, color: TEXT_MUTED, padding: "16px 0", textAlign: "center", background: GRAY, borderRadius: 12 }}>暂无诊断数据</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {topConditions.map(([name, count], i) => {
              const maxCount = topConditions[0][1];
              return (
                <div key={name} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 18, fontSize: 12, fontWeight: 800, color: TEXT_MUTED }}>{i + 1}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 }}>
                      <span style={{ color: TEXT, fontWeight: 600 }}>{name}</span>
                      <span style={{ color: TEAL, fontWeight: 700 }}>{count} 次</span>
                    </div>
                    <div style={{ height: 6, background: GRAY, borderRadius: 4, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${(count / maxCount) * 100}%`, background: TEAL, borderRadius: 4 }} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* 严重程度分布 */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: TEXT, marginBottom: 10 }}>⚖️ 严重程度分布</div>
        <div style={{ display: "flex", gap: 10 }}>
          {Object.entries(severityCounts).map(([level, count]) => (
            <div key={level} style={{ flex: 1, textAlign: "center", padding: "14px 0", borderRadius: 12, background: GRAY }}>
              <div style={{ fontSize: 20, fontWeight: 800, color: severityColor(level) }}>{count}</div>
              <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 4 }}>{level}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 订单状态分布 */}
      <div>
        <div style={{ fontSize: 15, fontWeight: 800, color: TEXT, marginBottom: 10 }}>📦 订单状态分布</div>
        {Object.keys(orderStatusCounts).length === 0 ? (
          <div style={{ fontSize: 13, color: TEXT_MUTED, padding: "16px 0", textAlign: "center", background: GRAY, borderRadius: 12 }}>暂无订单数据</div>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {Object.entries(orderStatusCounts).map(([status, count]) => (
              <div key={status} style={{ padding: "8px 14px", borderRadius: 10, background: TEAL_LIGHT, fontSize: 13 }}>
                <span style={{ color: TEAL_DARK, fontWeight: 700 }}>{status}</span>
                <span style={{ color: TEXT, marginLeft: 6 }}>{count} 笔</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function StatCard({ icon, label, value }) {
  return (
    <div style={{ padding: "16px", borderRadius: 14, background: GRAY, border: "1.5px solid #EEF4F4" }}>
      <div style={{ fontSize: 20, marginBottom: 6 }}>{icon}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: TEAL }}>{value}</div>
      <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 2 }}>{label}</div>
    </div>
  );
}

// ─── Tab Bar ──────────────────────────────────────────────────────
function TabBar({ tab, setTab, isAdmin }) {
  const tabs = isAdmin
    ? [{ key: "admin", icon: "⚙️", label: "商品管理" }]
    : [
        { key: "diagnosis", icon: "🔬", label: "诊断" },
        { key: "knowledge", icon: "📖", label: "科普" },
        { key: "shop", icon: "🛍️", label: "商品" },
        { key: "profile", icon: "👤", label: "我的" },
      ];

  return (
    <div style={{ position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: 520, background: "white", borderTop: "1px solid #EEF4F4", display: "flex", zIndex: 100, boxShadow: "0 -4px 20px rgba(0,0,0,0.06)" }}>
      {tabs.map((t) => (
        <button key={t.key} onClick={() => setTab(t.key)} style={{ flex: 1, padding: "12px 0 10px", display: "flex", flexDirection: "column", alignItems: "center", gap: 4, background: "none", border: "none", cursor: "pointer" }}>
          <span style={{ fontSize: 22 }}>{t.icon}</span>
          <span style={{ fontSize: 11, fontWeight: 700, color: tab === t.key ? TEAL : TEXT_MUTED }}>{t.label}</span>
          {tab === t.key && <div style={{ width: 20, height: 3, borderRadius: 2, background: TEAL, marginTop: 1 }} />}
        </button>
      ))}
    </div>
  );
}

// ─── App Root ─────────────────────────────────────────────────────
// ⚠️ 自定义这个隐藏路径，越独特越安全，例如改成你自己的暗号
const ADMIN_SECRET_PATH = "/admin-secret-2026";

export default function App() {
  const [role, setRole] = useState(null); // null | "user" | "admin"
  const [tab, setTab] = useState("diagnosis");
  const [products, setProducts] = useState([]);

  const isAdminPath = typeof window !== "undefined" &&
    window.location.pathname === ADMIN_SECRET_PATH;

  useEffect(() => {
    loadProducts().then(setProducts);
  }, []);

  if (!role) return <LoginPage isAdminPath={isAdminPath} onLogin={(r) => { setRole(r); setTab(r === "admin" ? "admin" : "diagnosis"); }} />;

  return (
    <div style={{ maxWidth: 520, margin: "0 auto", fontFamily: "'PingFang SC', 'Helvetica Neue', sans-serif" }}>
      {tab === "diagnosis" && <DiagnosisPage onGoShop={() => setTab("shop")} />}
      {tab === "knowledge" && <KnowledgePage />}
      {tab === "shop" && <ShopPage />}
      {tab === "profile" && <ProfilePage />}
      {tab === "admin" && <AdminPage products={products} setProducts={setProducts} />}
      <TabBar tab={tab} setTab={setTab} isAdmin={role === "admin"} />
    </div>
  );
}